import Layout from "../../../components/Frames/Layout";
import { useQuery} from 'react-query';
import API from '../../../services/API'
import Grid from "../../Tools/Grid";
import Chip from "../../Tools/Chip";
import { Rating, Stack, Button, Typography, IconButton } from "@mui/material";
import { Link } from "react-router-dom";
import { Add, Check, Close, Edit, Euro, Visibility } from "@mui/icons-material";
import moment from "moment";

export default function List(){

    const {data, isSuccess} = useQuery('courses', () => 
        API.get('/admin/courses').then(r => r.data)
    );

    const columns = [
        {
            field: 'title',
            headerName: 'Formation',
            width: 350,
            valueGetter: p => p.row.title,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'category',
            headerName: 'Filière',
            width: 155,
            valueGetter: p => p.row.category?.title,
            renderCell: p => 
                <Stack direction='row' spacing={1} alignItems='center'>
                    <Chip color={p.row.category?.color} size={14}/>
                    <Typography variant='span'>{p.value}</Typography>
                </Stack>,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'enrollments',
            headerName: 'Inscrits',
            width: 70,
            type: 'number',
            valueGetter: p => p.row.enrollments?.count || 0,
            renderCell: p => p.value.toLocaleString(),
            aggregable: false,
            groupable: false,
        },
        {
            field: 'revenue',
            headerName: 'CA',
            width: 100,
            type: 'number',
            valueGetter: p => p.row.enrollments?.amount || 0,
            renderCell: p => <span>{p.value.toLocaleString()}<small>€</small></span>,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'completion',
            headerName: 'Complétion',
            width: 90,
            type: 'number',
            valueGetter: p => p.row.enrollments?.completion || 0,
            renderCell: p => <span>{p.value.toLocaleString()}<small>%</small></span>,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'rating',
            headerName: 'Satisfaction',
            width: 150,
            type: 'number',
            valueGetter: p => p.row.reviews?.average || 0,
            renderCell: p => 
                <Stack alignItems='center'>
                    <Rating value={p.value} precision={0.1} size='small' readOnly/>
                    <small>{p.value.toFixed(1)}/5 ({p.row.reviews?.count})</small>
                </Stack>,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'pi',
            headerName: 'PI',
            width: 50,
            type: 'boolean',
            valueGetter: p => p.row.pi,
            renderCell: p => <>
                {p.value ? 
                    <Check color='primary' sx={{width: 20}}/> : 
                    <Close color='error' sx={{width: 20}}/>
                }
            </>,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'prices',
            headerName: 'Tarifs',
            width: 70,
            valueGetter: p => p.row.id,
            renderCell: p => <Link to={`/admin/products?course=${p.value}`}>
                <IconButton size='small'>
                    <Euro />
                </IconButton>
            </Link>,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'see',
            headerName: 'Voir',
            width: 70,
            valueGetter: p => p.row.id,
            renderCell: p => 
                <Link to={`/study/${p.value}`}>
                    <IconButton size='small'>
                        <Visibility />
                    </IconButton>
                </Link>,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'edit',
            headerName: 'Editer',
            width: 70,
            valueGetter: p => p.row.id,
            renderCell: p => 
                <Link to={`/design/${p.value}`}>
                    <IconButton size='small'>
                        <Edit />
                    </IconButton>
                </Link>,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'createdAt',
            headerName: 'Créée le',
            width: 94,
            type: 'date',
            valueGetter: p => moment(p.row.createdAt).toDate(),
            renderCell: p => moment(p.row.createdAt).format('DD/MM/YYYY à HH:mm'),
            aggregable: false,
            groupable: false,
        },
    ];

    return <Layout title="Catalogue de formations" tab="courses" menu="admin">

        <Link to='/design/new'>
            <Button 
                variant='contained'
                startIcon={<Add />}
                sx={{mb: 1}}
            >
                Ajouter
            </Button>
        </Link>

        <Grid 
            id='coursesGrid'
            columns={columns}
            rows={isSuccess ? data : null}
            toolbar
        />

    </Layout>
}







